import { createAction, props } from '@ngrx/store';
import { otherClasses, PeriodState } from './class.reducer';

export const setTermObject = createAction(
  '[Period] Set User Object',
  props<Partial<PeriodState>>()
);

export const loadOtherClasses = createAction(
  '[OtherClasses] Load',
  props<{ data: otherClasses[] }>()
);

export const loadBulkTeachingClasses = createAction(
  '[Class] Load Bulk Teaching Classes',
  props<{ data: otherClasses[] }>()
);
